// 动漫网 - 关于我们页数据

export const aboutBrand = {
  slogan: '你的二次元资源聚合站',
  intro: [
    '动漫网成立于 2018 年，是专注于动漫、动画与漫画资源聚合与索引的垂直内容平台。我们致力于为每一位二次元爱好者提供高效、清晰、专业的找番与追更体验。',
    '从日漫到国漫，从新番速递到经典老番，从热血战斗到治愈日常，动漫网现已收录数以万计的动画与漫画作品，建立了涵盖题材、年份、制作公司等多维度的精细化分类体系。',
    '我们相信，好的内容值得被更好地发现。动漫网以用户为中心，持续优化检索与推荐逻辑，让每一位用户都能更快地找到真正想看的作品。',
  ],
  values: [
    {
      icon: 'ri-compass-3-line',
      title: '精准索引',
      desc: '建立多维度的作品分类与标签体系，让找番变得简单高效。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '新番速递',
      desc: '每季抢先整理新番情报，第一时间掌握追番动态。',
    },
    {
      icon: 'ri-group-line',
      title: '共建社区',
      desc: '汇聚众多同好，共享推荐与讨论，一起发现好作品。',
    },
    {
      icon: 'ri-star-smile-line',
      title: '品质保障',
      desc: '内容经过严格筛选，确保推荐作品的质量与口碑。',
    },
  ],
  honors: [
    { icon: 'ri-award-line', title: '2024 年度最佳动漫垂直平台', org: '数字内容产业协会' },
    { icon: 'ri-trophy-line', title: '最受用户欢迎内容社区', org: 'ACG 用户口碑评选' },
    { icon: 'ri-medal-line', title: '原创内容贡献奖', org: '国产动画发展论坛' },
    { icon: 'ri-star-line', title: '用户增长标杆案例', org: '新经济观察年度盘点' },
  ],
  stats: [
    { label: '收录作品', value: '12,000+' },
    { label: '细分标签', value: '860+' },
    { label: '注册用户', value: '380 万' },
    { label: '每日更新', value: '200+' },
  ],
  contact: {
    email: 'contact@dongmanwang.com',
    phone: '010-8888-6666',
    address: '北京市朝阳区建国路 88 号 SOHO 现代城',
    worktime: '周一至周五 9:00 - 18:00',
    wechat: 'dongmanwang',
  },
};